/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  /**
   * Подтверждение добавления в корзину товаров из истории
   */
  app.ConfirmRepeatPopupView = app.View.extend({
    el: '.confirm-repeat-order-popup',

    events: {
      'click .js-repeat-order': 'repeatOrder',
    },

    additionalOptions: [
      'orderId',
      'faderView',
    ],

    /**
     * @inheritDoc
     */
    run: function () {
      this.popup = new als.Popup(this.$el);
      if (!app.isMobile) {
        this.addDesktopEventsPopupOrderRepeat();
      }
      this.show();
    },

    /**
     * Показывает попап
     */
    show: function() {
      // Костыль для лебедевского попапа
      setTimeout(this.popup.open.bind(this.popup), 0);
    },

    /**
     * События попапа для десктопных устройств
     */
    addDesktopEventsPopupOrderRepeat: function() {
      var fader = this.faderView;
      this.popup.addEventListener(
        als.Popup.EventType.BEFORE_OPEN,
        function () {
          app.helpers.PopupPositioningHelper.positionCenterOfWindow(this.$el);
          if (fader instanceof app.FaderView) {
            fader.show();
          }
        }.bind(this)
      );
      this.popup.addEventListener(
        als.Popup.EventType.AFTER_CLOSE,
        function () {
          if (fader instanceof app.FaderView) {
            fader.hide();
          }
        }
      );
    },

    /**
     * Обработчик события клика по кнопке "Подтвердить"
     * @param {Event} e Событие
     */
    repeatOrder: function(e) {
      var $el = this.$(e.currentTarget);
      var orderId = this.orderId;
      $el.attr('disabled', true);
      app.preloader.render();
      app.helpers.OkoHelper.awaitPush(
        {
          'n': 'custom',
          'category': 'order_repeat',
          'custom_int': [orderId],
        },
        function () {
          orderId && app.helpers.RedirectHelper.locationAssign('/order/repeat/' + orderId + '/');
        });
    }
  });
})(jQuery);

}.call(window));